/**
 * Order settings API client (BFF: `/api/v1/store/settings/orders`).
 *
 * Covers order behaviour settings plus the order lifecycle (statuses + allowed
 * transitions) sub-resource.
 */
import { apiClient } from '@/shared/api';
import type {
  OrderLifecycleSettings,
  OrderSettings,
  UpdateOrderLifecycleRequest,
  UpdateOrderSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/orders';

export const getOrderSettings = async (): Promise<OrderSettings> =>
  (await apiClient.get<OrderSettings>(BASE)).data;

export const updateOrderSettings = async (
  body: UpdateOrderSettingsRequest,
): Promise<OrderSettings> => (await apiClient.put<OrderSettings>(BASE, body)).data;

export const getOrderLifecycle = async (): Promise<OrderLifecycleSettings> =>
  (await apiClient.get<OrderLifecycleSettings>(`${BASE}/lifecycle`)).data;

export const updateOrderLifecycle = async (
  body: UpdateOrderLifecycleRequest,
): Promise<OrderLifecycleSettings> =>
  (await apiClient.put<OrderLifecycleSettings>(`${BASE}/lifecycle`, body)).data;
